import { Component, OnInit } from '@angular/core';
import { FascicoloFull } from 'src/app/common/models/fascicolo/fascicolo-full';
import { DialogConfig } from 'src/app/core/components/dialog/dialog-config';
import { DialogRef } from 'src/app/core/components/dialog/dialog-ref';

@Component({
  selector: 'app-selezione-fascicoli-secondari',
  templateUrl: './selezione-fascicoli-secondari.component.html',
  styleUrls: ['./selezione-fascicoli-secondari.component.css']
})
export class SelezioneFascicoliSecondariComponent implements OnInit {
  fascicoliSecondari: FascicoloFull[] = [];
  fascicoloSelezionato: FascicoloFull | null = null;
  title = 'Seleziona fascicoli secondari';
  message: string | null = null;
  constructor(
    private dialogConfig: DialogConfig,
    private dialogRef: DialogRef,
  ) {}

  ngOnInit(): void {
    const available: FascicoloFull[] = this.dialogConfig.data?.fascicoliDisponibili ?? [];
    const currentFascicolo: any = this.dialogConfig.data?.fascicoloCorrente ?? null;
    // chiave che identifica univocamente il fascicolo
    const keyOf = (f: any) => f?.idFascicolo ?? f?.id ?? f?.posizioneFascicolo ?? JSON.stringify(f);

    const map = new Map<string, FascicoloFull>();
    for (const f of available) {
      const key = keyOf(f);
      const currentKey = currentFascicolo ? keyOf(currentFascicolo) : null;
      // escludo il fascicolo corrente e i duplicati
      if (currentKey && key === currentKey) {
        continue;
      }
      if (!map.has(key)) {
        map.set(key, f);
      }
    }

    this.fascicoliSecondari = Array.from(map.values());
    this.title = this.dialogConfig.data?.title ?? this.title;
    this.message = this.dialogConfig.data?.message ?? null;
  }

  selezionaFascicolo(fasc: any) {
    // se clicco di nuovo sullo stesso, lo deseleziono
    this.fascicoloSelezionato = this.fascicoloSelezionato === fasc ? null : fasc;
  }

  confermaSelezione() {
    this.dialogRef.close({
      modalEvent: true,
      selectedFascicolo: this.fascicoloSelezionato ?? null
    });
  }

  annulla() {
    this.dialogRef.close({ modalEvent: false });
  }

  trackByFascicolo(index: number, fasc: any) {
    return fasc?.idFascicolo ?? fasc?.id ?? fasc?.posizioneFascicolo ?? index;
  }
}
